import { mutateWorks, WORK_KEY } from "@/api/work/useWorkQuery";
import { COMMON_TEXT } from "@/constants/text";
import { customNotification } from "@/utils/notificationShow";
import { DefaultApiWorksWorkIdPutRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useWorkHandler = () => {
  const queryClient = useQueryClient();
  const { mutate: InventoriesMutate } = useMutation(
    (params: DefaultApiWorksWorkIdPutRequest) =>
      mutateWorks.update(params).mutationFn(undefined),
    {
      onSuccess: (data) => {
        // 성공 메시지 표시
        customNotification.success({
          message: COMMON_TEXT.NOTIFICATION.SETTING_EQUIPMENT_SUCCESS,
        });
        // 쿼리 무효화
        queryClient.invalidateQueries([WORK_KEY]);
      },
    }
  );

  const onSubmit = ({
    DefaultApiWorksWorkIdPutRequest,
    successCallback,
  }: {
    DefaultApiWorksWorkIdPutRequest: DefaultApiWorksWorkIdPutRequest;
    successCallback?: (data: any) => void;
  }) => {
    InventoriesMutate(DefaultApiWorksWorkIdPutRequest, {
      onSuccess: (data) => {
        if (successCallback) {
          successCallback(data);
        }
      },
    });
  };

  return { onSubmit };
};
